import React from 'react';
import {Redirect} from "react-router-dom";
import Session from "../helpers/Session";
import AppMenu from "./AppMenu";
import {withRouter} from 'react-router-dom'


class ValidLogin extends React.Component {


    render() {

        if (this.props.redirect) {
            Session.setRedirectTo(this.props.location.pathname);
        }

        if (!Session.getLogin()) {
            return (<Redirect to='/'/>)
        } else {
            return (
                <div>
                    <AppMenu/>
                    {this.props.path}
                </div>);
        }
    }

}

export default withRouter(ValidLogin)